// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"392":"28921702","1677":"db5e5e34","3571":"db5e5e34"}[chunkId] + ".chunk.css";
};